<template>
  <div class="app-layout" :class="{'unauth': !authenticatedUser}">
    <hypto-loader />
    <pending-verification v-if="getterPopupName === 'BlockedAccount'"  />

    <header :class="{
        'header': true,
        'public-space': !authenticatedUser,
        'reverse': isUserLoggedIn && getterTargetPage !== 'ANY'
      }">
      <div v-if="!isDesktop() && !authenticatedUser" class="m-width">
        <button @click="logoutUser" v-if="isUserLoggedIn">Logout</button>
      </div>

      <div :class="{'header-options': isDesktop() || isUserLoggedIn}">
        <span v-if="authenticatedUser" class="m-width" style="text-align: left">
          <div class="expand-collapse" @click="toggleNavBar">
            <i class="fa fa-times" v-if="!isDesktop() && showNavBar" />
            <i class="fa fa-bars" v-else />
          </div>
        </span>

        <div v-if="authenticatedUser" @click="goDashboard" style="cursor: pointer; margin: auto">
          <img src="@/assets/images/header-logo.svg" alt="Hypto Logo" />
        </div>

        <div v-if="backIcon" @click="goBack()" class="m-width" style="text-align: right">
          <i class="fa fa-arrow-left" />
        </div>
        <div v-else-if="!isDesktop() && authenticatedUser" class="m-width" />
      </div>

      <span class="m-width pos-abs" v-if="!authenticatedUser || isDesktop()">
        <a href="https://www.hypto.in/docs" target="_blank">API Docs</a>
        <button v-if="authenticatedUser && isDesktop()" @click="showStatus">
          Status
        </button>
        <button @click="logoutUser" v-if="isUserLoggedIn && isDesktop()">Logout</button>
      </span>
    </header>

    <section>
      <transition name="fade" v-if="authenticatedUser">
        <div v-if="showNavBar && !isDesktop()" class="freeze" @click="showNavBar = !showNavBar" />
      </transition>

      <transition name="slide">
        <div v-if="authenticatedUser && (desktopWidth() || showNavBar)"
            :class="{'expand': showNavBar, 'nav-bar': true}">
          <div class="router-link">
            <router-link v-for="(navData, index) in navList" :key="index" :to="{name: navData.route}"
                        @click.native="mobileToggleNav" :title="navData.name">
              <i class="fa" :class="navData.icon" />
              <p>{{navData.name}}</p>
            </router-link>
          </div>

          <div v-if="showNavBar && !isDesktop()">
            <a href="https://www.hypto.in/docs" target="_blank">
              <i class="fa fa-file-alt" />
              <p>API Docs</p>
            </a>
            <a @click="showStatus">
              <i class="fa fa-clock" />
              <p>
                Status
              </p>
            </a>
            <a @click="logoutUser">
              <i class="fa fa-sign-out-alt" />
              <p>Logout</p>
            </a>
            <a href="https://www.hypto.in/docs" target="_blank" class="api-version">
              API - v1.0.0
            </a>
          </div>
          <div v-if="isDesktop()" class="api-version">
            <a href="https://www.hypto.in/docs" target="_blank">
              API - v1.0.0
            </a>
          </div>
        </div>
      </transition>

      <div class="route-section" :class="{'extra-padding': authenticatedUser}">
        <notification-bar v-if="userBlocked" />

        <unprivilege-panel v-if="unprivilegeSections.includes(getterUnprivilegePage)"
                          :css="'section-panel'" :title="getterUnprivilegePage" />
        <transition v-else :name="recordTransition">
          <router-view :class="{'extra-margin': userBlocked}" />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import HyptoLoader from '@/components/global/HyptoLoader'
import NotificationBar from '@/components/global/NotificationBar'
import UnprivilegePanel from '@/components/global/UnprivilegePanel'
import PendingVerification from '@/components/BlockedUsers/PendingVerification'

import ApiServices from '@/services/api'
import moment from 'moment'
import { resetVuexState } from '@/store'
import { goBack } from '@/utils/helpers'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'ApplicationLayout',
  components: { HyptoLoader, PendingVerification, NotificationBar, UnprivilegePanel },
  data () {
    return {
      showNavBar: false,
      navList: [
        {
          name: 'Dashboard',
          icon: 'fa-th-large',
          route: 'Dashboard'
        },
        {
          name: 'Virtual Accounts',
          icon: 'fa-university',
          route: 'VAList'
        },
        {
          name: 'UPIs',
          icon: 'fa-qrcode',
          route: 'UPI'
        },
        {
          name: 'Reports',
          icon: 'fa-file-alt',
          route: 'Reports'
        },
        {
          name: 'Bulk Imports',
          icon: 'fa-upload',
          route: 'ImportsList'
        },
        {
          name: 'Settings',
          icon: 'fa-cog',
          route: 'Settings'
        },
        {
          name: 'Invoices',
          icon: 'fa-receipt',
          route: 'Invoices'
        },
        {
          name: 'Users and Roles',
          icon: 'fa-user-circle',
          route: 'UserManagement'
        }
      ],
      partnerInfo: null,
      userInfo: null,
      backIcon: false,
      recordTransition: null,
      chatWithUs: false,
      userBlocked: false,
      unprivilegeSections: ['Virtual Account Details', 'UPI Details', 'Invoices', 'Bulk Imports', 'Import Details']
    }
  },
  created () {
    this.SET_USER_LOGGED_IN()
    this.SET_INITIAL_HISTORY(window.history.length)
    this.SET_TARGET_PAGE()
  },
  watch: {
    isUserLoggedIn (newVal) {
      if (!newVal) {
        this.recordTransition = null
        this.showNavBar = null
        this.partnerInfo = null
        this.userInfo = null
        this.userBlocked = false

        if (this.getterPgStatus === 'active') {
          this.navList.splice(3, 1)
        }

        localStorage.clear()
        resetVuexState()
        this.$router.push({name: 'Login'})
      }
    },
    '$route': {
      handler: 'sectionChanges'
    },
    '$mq': {
      handler: 'checkBackIcon',
      immediate: true
    },
    getterPgStatus (newVal) {
      if (newVal === 'active') {
        this.navList.splice(3, 0, {
          name: 'Payment Gateway',
          icon: 'fa-money-check',
          route: 'PaymentGateway'
        })
      }
    }
  },
  computed: {
    ...mapGetters(['isUserLoggedIn', 'getterTargetPage', 'getterPopupName', 'getterUnprivilegePage', 'getterPgStatus']),
    authenticatedUser () {
      if (this.isUserLoggedIn && this.getterTargetPage === 'ANY') {
        this.loadAdditionalComponents()
        return true
      }
      return false
    }
  },
  methods: {
    ...mapMutations(['SET_USER_LOGGED_IN', 'SET_INITIAL_HISTORY', 'SET_POPUP_NAME', 'SET_UNPRIVILEGE_PAGE', 'SET_TARGET_PAGE', 'SET_PG_STATUS']),
    goBack,
    moment,
    metaApi () {
      ApiServices.meta().then((response) => {
        let data = response.data
        this.partnerInfo = data.partner
        this.userInfo = data.user
        this.SET_PG_STATUS(this.partnerInfo.pg_status)

        if (this.partnerInfo.account_status === 'BLOCKED') {
          this.userBlocked = true
          this.SET_POPUP_NAME('BlockedAccount')
        }
      })
    },
    loadAdditionalComponents () {
      this.recordTransition = 'height'
      if (this.desktopWidth()) {
        let navSession = localStorage.getItem('show_nav_bar')
        this.showNavBar = navSession ? JSON.parse(navSession) : true
      }

      this.metaApi()
    },
    logoutUser () {
      ApiServices.logout()
    },
    sectionChanges () {
      this.checkBackIcon()
      this.SET_UNPRIVILEGE_PAGE(null)
    },
    checkBackIcon () {
      this.backIcon = !this.isDesktop() && this.$route.meta.parentRoute
    },
    toggleNavBar () {
      this.showNavBar = !this.showNavBar

      if (this.isDesktop()) {
        localStorage.setItem('show_nav_bar', this.showNavBar)
      }
    },
    mobileToggleNav () {
      if (!this.isDesktop()) {
        this.showNavBar = !this.showNavBar
      }
    },
    desktopWidth () {
      return document.body.clientWidth > 720
    },
    goDashboard () {
      this.SET_USER_LOGGED_IN()
      this.SET_TARGET_PAGE()
      this.$router.push({name: 'Dashboard'})
    },
    showStatus () {
      this.$router.push({name: 'Status'})
      this.mobileToggleNav()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  $headerHeight: 60px;

  .app-layout {
    height: 100vh;

    &.unauth {
      background: $secondary-gradient;
    }

    section {
      height: calc(100vh - #{$headerHeight});
      display: flex;

      .route-section {
        flex: 1;
        max-height: calc(100vh - #{$headerHeight});
        overflow: auto;
        @include custom-flex(null, null, column);
      }
    }
  }

  .header {
    @include custom-flex(space-between);
    width: 100%;
    height: $headerHeight;
    position: relative;
    z-index: 50;

    &:not(.public-space) {
      background: $white;
      box-shadow: 0px 5px 20px rgba(101, 109, 113, 0.1), 10px 10px 10px rgba(101, 109, 113, 0.1);

      img {
        height: 24px;
      }
    }

    &.public-space {
      a, button {
        font-weight: bold;
        transition: .3s;

        padding: 10px 20px;
        border-radius: 10px;
        border: 1px solid $white;
        @include normal-text($white !important, 16px);

        &:hover {
          background: $white;
          color: $secondary !important;
        }
      }
    }

    .header-options {
      @include custom-flex(space-between);
    }

    button, &:not(.public-space) a {
      @include normal-text($black-2, 16px);
      padding: 10px 20px;

      &:hover {
        opacity: .9;
        color: inherit;
      }
    }
  }

  .router-link-active {
    @include primary-props;

    p {
      font-weight: bold !important;
    }

    .fa, p {
      color: $white !important;
    }
  }

  .desktop {
    .header {
      &.public-space {
        padding: 0 15px;

        .pos-abs {
          position: absolute;
          right: 40px;
          top: 40px;
        }

        a, button {
          margin-left: 10px;
        }
      }

      .header-options {
        .expand-collapse {
          width: 60px;
          height: 60px;
          @include custom-flex();
          margin-right: 10px;
          cursor: pointer;

          &:hover {
            background: $grey-outline;
          }
        }
      }
    }

    .nav-bar {
      height: 100%;
      width: 60px;

      background: $secondary-gradient;
      border-right: 1px solid $grey-outline;

      &.expand {
        width: 230px;

        .router-link > a {
          p {
            display: block !important;
          }
        }
      }

      .router-link > a {
        padding: 20px;
        text-align: left;
        display: flex;
        @include normal-text($white !important, 18px);
        position: relative;

        &:hover {
          background: rgba(101, 109, 113, .2);
        }

        p {
          display: inline-block;
          @include normal-text($white, 15px, normal);
          margin: 0 10px;
          display: none;
        }
        .fa {
          @include highlight-text(rgba(255, 255, 255, .4), 18px, 900);
          min-width: 25px;
        }
      }

      .api-version {
        position: absolute;
        bottom: 0;
        margin: 10px 0;
        width: inherit;

        a {
          @include normal-text($grey-light, 13px, 500);
        }
      }
    }

    section {
      .extra-padding {
        padding: 20px;
      }
    }
  }

  .tablet, .mobile {
    section {
      height: calc(100vh - #{$headerHeight});
      overflow: auto;

      .extra-padding {
        padding: 10px;
      }

      .extra-margin {
        margin-bottom: 80px;
      }
    }

    .header {
      &.public-space {
        padding: 0 8px;

        .m-width {
          margin: 15px 0 0;
        }
      }
      &.reverse {
        flex-direction: row-reverse !important;
      }
      &:not(.public-space) {
        background: $white;
      }

      .header-options {
        width: 100%;
      }

      .m-width {
        min-width: 85px;
      }

      .fa {
        font-size: 20px;
        padding: 0 10px;
      }

      .fa-bars, .fa-arrow-left {
        color: $primary;
      }

      .pos-abs {
        position: absolute;
        left: 0;
        right: 0;
        z-index: -1;
      }

      a {
        white-space: nowrap;
      }
    }

    .freeze {
      position: fixed;
      top: 60px;
      left: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0,0,0,0.6);
      z-index: 1100;
    }

    .nav-bar {
      position: fixed;
      top: 60px;
      left: 0;
      background: $secondary;
      min-width: 250px;
      width: 60%;
      z-index: 1200;
      height: calc(100vh - 60px);
      @include custom-flex(space-between, null, column);
      overflow: auto;

      a {
        @include custom-flex(flex-start);
        color: $white;
        font-weight: bold;
        padding: 15px;

        .fa {
          margin-right: 10px;
        }
      }
    }

    .slide-enter {
      transform: translateX(-200px);
    }
    .slide-enter-to {
      transform: translateX(0);
      transition: .6s;
    }

    .slide-leave {
      transform: translateX(0);
    }
    .slide-leave-to {
      transform: translateX(-200px);
      transition: .3s;
    }

    .fade-enter-active {
      opacity: 0;
    }
    .fade-enter-to {
      opacity: 1;
      transition: .6s;
    }

    .fade-leave-active {
      opacity: 1;
    }
    .fade-leave-to {
      opacity: 0;
      transition: .4s;
    }
  }
</style>
